const SummaryTableSchema = [
    {
        objectName: 'selectedlocalShipment',
        isLoading: 'loadingWorksaleLineDetailsSummary',
        children: [
            {
                label: 'From Warehouse',
                fieldNames: [
                    'FromWarehouse'
                ]
            },
            {
                label: 'To Warehouse',
                fieldNames: [
                    'ToWarehouse'
                ]
            },
            {
                label: 'Shipment No',
                fieldNames: [
                    'Shipment'
                ]
            },
            {
                label: 'Entered',
                fieldNames: [
                    'EnteredDate'
                ]
            },
        ]
    },
];

export default SummaryTableSchema;
